/**
 * Util for retrieving network information using the Network Information API.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Network_Information_API.
 */
export const getNetworkInfo = () => {
    // We use `any` here as window.navigator is different depending on the browser version
    const navigator = window.navigator;
    const connection = navigator
        ? navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection ||
            {}
        : {};
    const downlink = connection.downlink;
    const effectiveType = connection.effectiveType;
    let info = {};
    if (downlink) {
        info = {
            downlink,
        };
    }
    if (effectiveType) {
        info = Object.assign(Object.assign({}, info), { effectiveType });
    }
    const hasInfo = Object.keys(info).length > 0;
    return hasInfo ? info : undefined;
};
